.metricas { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: var(--s-6); }
.filtros { display: flex; align-items: center; flex-wrap: wrap; gap: var(--s-5); }
.busqueda { width: 300px; }
.nombre { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
@media (max-width: 900px) { .metricas { grid-template-columns: minmax(0, 1fr); } .busqueda { width: 100%; } }
